export default __webpack_public_path__ + "static/media/sound.3757d371.svg";